import { useState } from "react";
import { PopupModal } from "../../../components/Modal";
import { useResetPricingConfig } from "../hooks";

export function ResetConfigModal({
  userId,
  onClose,
}: {
  userId: string;
  onClose: () => void;
}) {
  const [scope, setScope] = useState<"base" | "all">("base");
  const resetMutation = useResetPricingConfig();

  const handleConfirm = () => {
    resetMutation.mutate(
      { userId, scope },
      { onSuccess: () => onClose() },
    );
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="mx-auto max-w-[440px] w-full"
    >
      <h3 className="text-lg font-semibold text-content-primary">
        Reset to Defaults
      </h3>

      <p className="text-sm text-content-secondary">
        This will reset the pricing configuration to system defaults. This
        action cannot be undone.
      </p>

      <div className="flex flex-col gap-2">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="scope"
            checked={scope === "base"}
            onChange={() => setScope("base")}
            className="accent-primary"
          />
          <span className="text-sm text-content-primary">
            Reset base config only
          </span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="scope"
            checked={scope === "all"}
            onChange={() => setScope("all")}
            className="accent-primary"
          />
          <span className="text-sm text-content-primary">
            Reset base config + delete all rules
          </span>
        </label>
      </div>

      <div className="flex justify-end gap-2">
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-content-secondary bg-surface-secondary rounded hover:bg-surface-hover"
        >
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          disabled={resetMutation.isPending}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded hover:bg-red-700 disabled:opacity-50"
        >
          {resetMutation.isPending ? "Resetting..." : "Reset"}
        </button>
      </div>
    </PopupModal>
  );
}
